import { render, staticRenderFns } from "./UValidationChecker.vue?vue&type=template&id=5381551f&scoped=true"
import script from "./UValidationChecker.vue?vue&type=script&lang=js"
export * from "./UValidationChecker.vue?vue&type=script&lang=js"
import style0 from "./UValidationChecker.vue?vue&type=style&index=0&id=5381551f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381551f",
  null
  
)

export default component.exports